import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";
import { Menu, X } from "lucide-react";
import logo from "../../assets/logos/logo.png";

type HeaderProps = {
  onSignIn?: () => void;
};

export const Header: React.FC<HeaderProps> = ({ onSignIn }) => {
  const { t } = useTranslation('common');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const handleSignIn = () => {
    if (onSignIn) return onSignIn();
    window.location.href = '/login';
  };

  return (
    <header className="bg-white/80 backdrop-blur-md border-b border-border sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <img
            src={logo}
            alt="Xentrix Flow Logo"
            className="w-12 h-12"
          />
          <span className="text-xl font-bold text-foreground">Xentrix Flow</span>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8">
          <a href="/home" className="text-muted-foreground hover:text-foreground transition-colors">
            {t('landing.header.home')}
          </a>
          <a href="/about" className="text-muted-foreground hover:text-foreground transition-colors">
            {t('landing.header.about')}
          </a>
          <a href="/contact" className="text-muted-foreground hover:text-foreground transition-colors">
            {t('landing.header.contact')}
          </a>
        </nav>

        {/* Desktop CTA */}
        <div className="hidden md:flex space-x-4">
          <Button variant="hero" onClick={handleSignIn}>{t('landing.header.signIn')}</Button>
        </div>

        {/* Mobile Menu Button */}
        <Button
          variant="hero"
          size="icon"
          className="md:hidden"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? <X /> : <Menu />}
        </Button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden bg-background border-t border-border">
          <nav className="container mx-auto px-4 py-4 flex flex-col space-y-4">
            <a href="#features" className="text-muted-foreground hover:text-foreground transition-colors">
              {t('landing.header.features')}
            </a>
            <a href="#platforms" className="text-muted-foreground hover:text-foreground transition-colors">
              {t('landing.header.platforms')}
            </a>
            <a href="/contact" className="text-muted-foreground hover:text-foreground transition-colors">
              {t('landing.header.contact')}
            </a>
            <div className="flex flex-col space-y-2 pt-4">
              <Button variant="hero" onClick={handleSignIn}>{t('landing.header.signIn')}</Button>
              {/* <Button variant="hero">Get Started</Button> */}
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};
